"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M4 5.5A1.5 1.5 0 0 1 5.5 4h7A1.5 1.5 0 0 1 14 5.5V8a.5.5 0 0 1-.5.5H11A2.5 2.5 0 0 0 8.5 11v2.5a.5.5 0 0 1-.5.5H5.5A1.5 1.5 0 0 1 4 12.5z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M10 11.5a1.5 1.5 0 0 1 1.5-1.5h7a1.5 1.5 0 0 1 1.5 1.5v7a1.5 1.5 0 0 1-1.5 1.5h-7a1.5 1.5 0 0 1-1.5-1.5z"
  })]
}), 'CopyFilled');
//# sourceMappingURL=index.js.map